import React, { useEffect, useState } from "react";
import "../components/component.css";
import { GiExitDoor, GiTongue } from "react-icons/gi";
import { FaBars, FaTasks, FaUserFriends } from "react-icons/fa";
import { ImCross } from "react-icons/im";

import { IoNotificationsSharp } from "react-icons/io5";
import axios from "axios";
import Cookies from "js-cookie";
import { DownOutlined } from '@ant-design/icons';
import { MenuProps } from 'antd';
import { Dropdown, Space } from 'antd';


import {
  MdBiotech,
  MdDataExploration,
  MdEmail,
  MdEvent,
  MdLabel,
  MdMedicalInformation,
  MdOutlineAnalytics,
  MdOutlineAppRegistration,
  MdOutlineQueryStats,
  MdOutlineSpaceDashboard,
  MdOutlineWeb,
} from "react-icons/md";
import {
  FaBacteria,
  FaBowlFood,
  FaBucket,
  FaCartShopping,
  FaChalkboardUser,
  FaClipboardQuestion,
  FaHandHoldingMedical,
  FaKitMedical,
  FaRegCircleUser,
  FaRegUser,
  FaTentArrowDownToLine,
} from "react-icons/fa6";
import { HiOutlineUsers, HiUserGroup } from "react-icons/hi2";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { CgProfile, CgReorder } from "react-icons/cg";
import { useNavigate } from "react-router-dom";

import {
  GiDna1,
  GiDna2,
  GiInsectJaws,
  GiLiver,
  GiMicroscope,
} from "react-icons/gi";
import { FcBiomass } from "react-icons/fc";
import {
  FaMapMarkedAlt,
  FaMicroscope,
  FaShippingFast,
  FaShoppingCart,
  FaTicketAlt,
  FaUpload,
} from "react-icons/fa";
import { BiHelpCircle } from "react-icons/bi";
import { IoFastFood, IoFastFoodOutline, IoTicketSharp } from "react-icons/io5";
import { BsCalendar2EventFill } from "react-icons/bs";
import { SiAdobeacrobatreader, SiGoogleadsense, SiGooglemeet } from "react-icons/si";
import { RiMailSendLine, RiMicroscopeLine } from "react-icons/ri";
import { Badge, message } from "antd";







import { MdOutlineEmail } from "react-icons/md"
// import { FaBacteria, FaBowlFood, FaChalkboardUser, FaClipboardQuestion, FaKitMedical } from "react-icons/fa6"
// import { HiOutlineUsers, HiUserGroup } from 'react-icons/hi2'
// import { HiOutlineDocumentReport } from "react-icons/hi"
import { CgTemplate } from "react-icons/cg"
// import { useNavigate } from 'react-router-dom'
// import Cookies from 'js-cookie';
import { GiReturnArrow } from 'react-icons/gi'
// import { FcBiomass } from "react-icons/fc";
import { FaWpforms } from 'react-icons/fa'
// import { BiHelpCircle } from 'react-icons/bi'
// import { IoFastFood, IoFastFoodOutline, IoTicketSharp } from 'react-icons/io5'
// import { BsCalendar2EventFill } from 'react-icons/bs'
import { SiAmazonsimpleemailservice } from 'react-icons/si'
import { RiSendPlaneLine } from "react-icons/ri";
import { TbReportSearch } from 'react-icons/tb'
import MainHeading from "./heading";


function Navbar() {
  const loginemail = Cookies.get("email");
  const loginname = Cookies.get("Name");
  const id = Cookies.get("id");
  const token = Cookies.get("Token");
  const token2 = Cookies.get("Token");
  const allergyMap = Cookies.get("allergyMap") || false;
  const navigate = useNavigate();
  const apiurlforbackend = process.env.REACT_APP_APIURL;

  const logout = () => {

    const cookiesToKeep = [
      "logourl",
      "backgroundcolor",
      "color",
      "Buttonbackgroundcolor",
      "Buttoninsidecolor",
      "prinarycolor",
      "prinarycolortext",
      "seconderycolor",
      "portalid",
      "dashboard",
      "microbiome",
      "microbiomePlus",
      "microbiomeAdvanced",
      "foodSensitivity",
      "foodSensitivityMap",
      "dnaMap",
      "parasitologyTest",
      "candidaProfile",
      "sampleReceived",
      "uploadResults",
      "allPractitioners",
      "dataAndAnalytics",
      "ordersInformation",
      "maps",
      "shipping",
      "whiteLabel",
      "academy",
      "meetings",
      "emails",
      "helpCenter",
      "profile"
    ];

    const allCookies = Cookies.get();

    for (const cookieName in allCookies) {
      if (!cookiesToKeep.includes(cookieName)) {
        Cookies.remove(cookieName);
      }
    }
    // const allCookies = Cookies.get();
    // for (const cookieName in allCookies) {
    //   Cookies.remove(cookieName);
    // }
    navigate("/");
  };

  const [manukonssa, setmanukonssa] = useState("0");

  const [manuuu, setmanu] = useState(false);
  const [manuuunoti, setmanuuunoti] = useState(false);
  const [notification, setnotification] = useState([]);
  const [tickets, settickets] = useState([]);

  const openNotification = async () => {
    try {
      if (token === "dskgfsdgfkgsdfkjg35464154845674987dsf@53") {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var requestOptions = {
          method: "GET",
          headers: myHeaders,
          redirect: "follow",
        };

        const response = await fetch(
          "https://yourgutmap-food-sensitivity-423a2af84621.herokuapp.com/getallnotification",
          requestOptions
        );

        const result = await response.json();

        await setnotification(result);

        // result.forEach(value => {
        //     if (!value.status) {
        //         const key = `${value._id}`;
        //         const btn = (
        //             <Space>

        //                 <Button type="primary" size="small" onClick={() => {
        //                     api.destroy(key)
        //                     var myHeaders = new Headers();
        //                     myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        //                     var urlencoded = new URLSearchParams();
        //                     urlencoded.append("_id", value._id);

        //                     var requestOptions = {
        //                         method: 'POST',
        //                         headers: myHeaders,
        //                         body: urlencoded,
        //                         redirect: 'follow'
        //                     };

        //                     fetch("https://yourgutmap-food-sensitivity-423a2af84621.herokuapp.com/editnotification", requestOptions)
        //                         .then(response => response.text())
        //                         .then(result => console.log(""))

        //                 }}>
        //                     Mark as Read
        //                 </Button>
        //             </Space>
        //         );
        //         api.open({
        //             message: value.title,
        //             description: value.contant,
        //             btn,
        //             key,
        //             duration: null,

        //         });
        //     }

        // });
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
      // Handle error (e.g., show error notification)
    }
  };

  const getticketsunread = async (idd) => {
    let data = JSON.stringify({
      id: idd,
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: apiurlforbackend + "/getallteamticketsbyidandunseen",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    await axios
      .request(config)
      .then((response) => {
        settickets(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (token === "dskgfsdgfkgsdfkjg35464154845674987dsf@53") {
      // const interval = setInterval(() => {
      getticketsunread(id);
      // }, 1000);

      // return () => clearInterval(interval);
    }
  }, []);

  useEffect(() => {
    openNotification();
  }, []);

  const count = () => {
    return notification.filter((item) => item.status === false).length;
  };

  const [show, setshow] = useState(false);

  useEffect(() => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    const urlencoded = new URLSearchParams();
    urlencoded.append("email", loginemail);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(
      "https://yourgutmap-food-sensitivity-423a2af84621.herokuapp.com/getmeetschudulebyemail",
      requestOptions
    )
      .then((response) => response.json())
      .then(async (result) => {
        if (id === result.id) {
          setshow(true);
          //    Cookies.set('Token2', "afdksjfjsdgfjgsdugcsduygfcsdvcfgsdcfgtysdftd", { expires: 7 }); // Expires in 7 days
        }
      })

      .catch((error) => console.error(error));
  }, []);








  const logourl = Cookies.get("logourl") || "empty.gif";

  // const logourl = Cookies.get("logourl") || "empty.gif";
  const backgroundcolor = Cookies.get("backgroundcolor") || "#999";
  const color = Cookies.get("color") || "#000";
  const Buttonbackgroundcolor = Cookies.get("Buttonbackgroundcolor") || "#dddddd";
  const Buttoninsidecolor = Cookies.get("Buttoninsidecolor") || "#000";
  const prinarycolor = Cookies.get("prinarycolor") || "#000";
  const prinarycolortext = Cookies.get("prinarycolortext") || "#000";
  const seconderycolor = Cookies.get("seconderycolor") || "#000";
  const portalid = Cookies.get("portalid") || "";

  const dashboard = Cookies.get("dashboard") || false;
  const microbiome = Cookies.get("microbiome") || false;
  const microbiomePlus = Cookies.get("microbiomePlus") || false;
  const microbiomeAdvanced = Cookies.get("microbiomeAdvanced") || false;
  const foodSensitivity = Cookies.get("foodSensitivity") || false;
  const foodSensitivityMap = Cookies.get("foodSensitivityMap") || false;
  const dnaMap = Cookies.get("dnaMap") || false;
  const parasitologyTest = Cookies.get("parasitologyTest") || false;
  const candidaProfile = Cookies.get("candidaProfile") || false;
  const sampleReceived = Cookies.get("sampleReceived") || false;
  const uploadResults = Cookies.get("uploadResults") || false;
  const allPractitioners = Cookies.get("allPractitioners") || false;
  const dataAndAnalytics = Cookies.get("dataAndAnalytics") || false;
  const ordersInformation = Cookies.get("ordersInformation") || false;
  const maps = Cookies.get("maps") || false;
  const shipping = Cookies.get("shipping") || false;
  const whiteLabel = Cookies.get("whiteLabel") || false;
  const academy = Cookies.get("academy") || false;
  const meetings = Cookies.get("meetings") || false;
  const emails = Cookies.get("emails") || false;
  const helpCenter = Cookies.get("helpCenter") || false;
  const profile = Cookies.get("profile") || false;



  const baseUrl = `${window.location.host}`;

  // useEffect(() => {
  //     let data = JSON.stringify({
  //         "url": baseUrl
  //     });

  //     let config = {
  //         method: 'post',
  //         maxBodyLength: Infinity,
  //         url: apiurlforbackend + '/get-portal-by-url',
  //         headers: {
  //             'Content-Type': 'application/json'
  //         },
  //         data: data
  //     };

  //     axios.request(config)
  //         .then((response) => {
  //             console.log(JSON.stringify(response.data));
  //             setlogourl(response.data.logourl)
  //             document.title = response.data.bartitle;
  //             setbackgroundcolor(response.data.backgroundcolor)
  //             setcolor(response.data.testcolor)
  //             setButtonbackgroundcolor(response.data.Buttonbackgroundcolor)
  //             setButtoninsidecolor(response.data.Buttoninsidecolor)
  //             setprinarycolor(response.data.prinarycolor)
  //             setprinarycolortext(response.data.prinarycolortext)
  //             setportalid(response.data._id)
  //             setseconderycolor(response.data.seconderycolor)

  //             setDashboard(response.data.dashboard);
  //             setMicrobiome(response.data.microbiome);
  //             setMicrobiomePlus(response.data.microbiomePlus);
  //             setMicrobiomeAdvanced(response.data.microbiomeAdvanced);
  //             setFoodSensitivity(response.data.foodSensitivity);
  //             setFoodSensitivityMap(response.data.foodSensitivityMap);
  //             setDnaMap(response.data.dnaMap);
  //             setParasitologyTest(response.data.parasitologyTest);
  //             setCandidaProfile(response.data.candidaProfile);
  //             setSampleReceived(response.data.sampleReceived);
  //             setUploadResults(response.data.uploadResults);
  //             setAllPractitioners(response.data.allPractitioners);
  //             setDataAndAnalytics(response.data.dataAndAnalytics);
  //             setOrdersInformation(response.data.ordersInformation);
  //             setMaps(response.data.maps);
  //             setShipping(response.data.shipping);
  //             setWhiteLabel(response.data.whiteLabel);
  //             setAcademy(response.data.academy);
  //             setMeetings(response.data.meetings);
  //             setEmails(response.data.emails);
  //             setHelpCenter(response.data.helpCenter);
  //             setProfile(response.data.profile);
  //         })
  //         .catch((error) => {
  //             console.log(error);
  //         });
  // }, [])



  // const manulist = [
  //   ((token === "dskgfsdgfkgsdfkjg35464154845674987dsf@53" ||
  //     token === "sdrfg&78967daghf#wedhjgasj(dlsh6kjsdg") &&
  //   {
  //     title: "NOTIFICATION",
  //     icon: <IoNotificationsSharp style={{ width: '20px', height: '20px', color: prinarycolor }} />,
  //     link: "/dashboard"
  //   },
  //   {
  //     title: "TASKS",
  //     icon: <FaTasks style={{ width: '20px', height: '20px', color: prinarycolor }} />,

  //     link: "/dashboard/teams/tickets"
  //   },

  //     (token === "dskgfsdgfkgsdfkjg35464154845674987dsf@53" && (sampleReceived === "true" && {
  //       title: "SAMPLE RECIEVED",
  //       icon: <FaHandHoldingMedical style={{ width: '20px', height: '20px', color: prinarycolor }} />,

  //       link: "/samplerecieved"
  //     }),

  //       (dataAndAnalytics === "true" && {
  //         title: "SAMPLE RETURN",
  //         icon: <GiReturnArrow style={{ width: '20px', height: '20px', color: prinarycolor }} />,

  //         link: "/samplereturn"
  //       }),
  //     {
  //       title: "KIT RECIEVED",
  //       icon: <FaTentArrowDownToLine style={{ width: '20px', height: '20px', color: prinarycolor }} />,

  //       link: "/kitack"
  //     },
  //       (shipping === "true" && {
  //         title: "SHIPPING FORM",
  //         icon: <FaShippingFast style={{ width: '20px', height: '20px', color: prinarycolor }} />,

  //         link: "/shipping"
  //       }),
  //       (dataAndAnalytics === "true" && {
  //         title: "EVENT INFO",
  //         icon: <MdEvent style={{ width: '20px', height: '20px', color: prinarycolor }} />,

  //         link: "/eventinfo"
  //       }),
  //       (uploadResults === "true" && {
  //         title: "BUCKET",
  //         icon: <FaBucket style={{ width: '20px', height: '20px', color: prinarycolor }} />,

  //         link: "/bucket"
  //       })),
  //   {
  //     title: "MY ACCOUNT",
  //     icon: <FaRegUser style={{ width: '20px', height: '20px', color: prinarycolor }} />,

  //     link: "/dashboard/profile"
  //   },
  //   {
  //     title: "LOGOUT",
  //     icon: <GiExitDoor style={{ width: '20px', height: '20px', color: prinarycolor }} />,

  //     link: 'logout'
  //   }),
  //   ...(
  //     token === "sdrfg&78967daghf#wedhjgasj(dlsh6kjsdg" &&
  //       baseUrl === "portal.yourgutmap.co.uk" &&
  //       sampleReceived === "true"
  //       ? [
  //         <h5
  //           key="order"
  //           className="hovar link"
  //           style={{
  //             margin: "0",
  //             display: "flex",
  //             alignItems: "center",
  //             justifyContent: "center",
  //             color: prinarycolor,
  //           }}
  //         >
  //           <a
  //             target="_blank"
  //             rel="noopener noreferrer"
  //             style={{ textDecoration: "none", color: prinarycolor }}
  //             href="https://yourgutmap.co.uk/shop/?v=1cd3c693132f"
  //           >
  //             Order Tests
  //           </a>
  //         </h5>,

  //         <h5
  //           key="book"
  //           className="hovar link"
  //           style={{
  //             margin: "0",
  //             display: "flex",
  //             alignItems: "center",
  //             justifyContent: "center",
  //             color: prinarycolor,
  //           }}
  //         >
  //           <a
  //             target="_blank"
  //             rel="noopener noreferrer"
  //             style={{ textDecoration: "none", color: prinarycolor }}
  //             href="https://meet.yourgutmap.co.uk/teams/nutrition"
  //           >
  //             Book Results Interpretation
  //           </a>
  //         </h5>,
  //       ]
  //       : []
  //   )


  // ]

  const manulist = [
    ...(token === "dskgfsdgfkgsdfkjg35464154845674987dsf@53" && portalid === "67c17d743394a458c944eec2")
      ? [{
        title: "NOTIFICATION",
        icon: <IoNotificationsSharp style={{ width: '20px', height: '20px', color: prinarycolor }} />,
        link: "/dashboard"
      }]
      : [],

    ...(token === "dskgfsdgfkgsdfkjg35464154845674987dsf@53" && portalid === "67c17d743394a458c944eec2")
      ? [{
        title: "TASKS",
        icon: <FaTasks style={{ width: '20px', height: '20px', color: prinarycolor }} />,
        link: "/dashboard/teams/tickets"
      }]
      : [],

    ...((token === "dskgfsdgfkgsdfkjg35464154845674987dsf@53" && sampleReceived === "true")
      ? [{
        title: "SAMPLE RECEIVED",
        icon: <FaHandHoldingMedical style={{ width: '20px', height: '20px', color: prinarycolor }} />,
        link: "/samplerecieved"
      }]
      : []),

    ...((token === "dskgfsdgfkgsdfkjg35464154845674987dsf@53" && dataAndAnalytics === "true")
      ? [{
        title: "SAMPLE RETURN",
        icon: <GiReturnArrow style={{ width: '20px', height: '20px', color: prinarycolor }} />,
        link: "/samplereturn"
      },
      {
        title: "EVENT INFO",
        icon: <MdEvent style={{ width: '20px', height: '20px', color: prinarycolor }} />,
        link: "/eventinfo"
      }]
      : []),

    ...((token === "dskgfsdgfkgsdfkjg35464154845674987dsf@53" && sampleReceived === "true")
      ? [{
        title: "KIT RECEIVED",
        icon: <FaTentArrowDownToLine style={{ width: '20px', height: '20px', color: prinarycolor }} />,
        link: "/kitack"
      }]
      : []),

    ...((token === "dskgfsdgfkgsdfkjg35464154845674987dsf@53" && shipping === "true")
      ? [{
        title: "SHIPPING FORM",
        icon: <FaShippingFast style={{ width: '20px', height: '20px', color: prinarycolor }} />,
        link: "/shipping"
      }]
      : []),

    ...((token === "dskgfsdgfkgsdfkjg35464154845674987dsf@53" && uploadResults === "true")
      ? [{
        title: "BUCKET",
        icon: <FaBucket style={{ width: '20px', height: '20px', color: prinarycolor }} />,
        link: "/bucket"
      }]
      : []),


    ...((token === "sdrfg&78967daghf#wedhjgasj(dlsh6kjsdg" && portalid === "67c17d743394a458c944eec2")
      ? [{
        title: "Order Tests",
        icon: <FaCartShopping style={{ width: '20px', height: '20px', color: prinarycolor }} />,
        link: "https://yourgutmap.co.uk/shop/?v=1cd3c693132f"
      }]
      : []),

    ...((token === "sdrfg&78967daghf#wedhjgasj(dlsh6kjsdg" && portalid === "67c17d743394a458c944eec2")
      ? [{
        title: "Book Results Interpretation",
        icon: <SiGooglemeet style={{ width: '20px', height: '20px', color: prinarycolor }} />,
        link: "https://meet.yourgutmap.co.uk/teams/nutrition"
      }]
      : []),

    {
      title: "MY ACCOUNT",
      icon: <FaRegUser style={{ width: '20px', height: '20px', color: prinarycolor }} />,
      link: "/dashboard/profile"
    },

    {
      title: "LOGOUT",
      icon: <GiExitDoor style={{ width: '20px', height: '20px', color: prinarycolor }} />,
      link: 'logout'
    },
    
  ];


  const navigation = (link) => {
    if (link === 'logout') {
      return logout();
    } else if (link === 'https://yourgutmap.co.uk/shop/?v=1cd3c693132f' || link === "https://meet.yourgutmap.co.uk/teams/nutrition") {


      window.open(link, "_blank");
    } else {


      navigate(link);
    }
  };


  const items = manulist.map((item, index) => ({
    key: index,
    label: (
      <div onClick={() => { navigation(item.link) }} style={{ display: 'flex', alignItems: 'center', gap: '10px', color: prinarycolor }}>
        {item.title}
      </div>
    ),
    icon: item.icon,

  }));

  const Profilelist = () => {


    return (
      <>
      <div style={{ cursor: 'pointer', color: prinarycolor, position: 'relative' }}>
        <div
        onClick={() => setmanuuunoti(!manuuunoti)}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '10px',
        }}
        >
        <h5
          className="hovar link"
          style={{
          margin: "0",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: prinarycolor,
          width: 'fit-content !important',
          }}
        >
          {loginname}
        </h5>
        <FaRegCircleUser style={{ width: '20px', height: '20px' }} />
        <DownOutlined />
        </div>
        {manuuunoti && (
        <>
          <div className="popupbg" style={{ backgroundColor: "rgba(0, 0, 0, 0.02)", cursor: "auto" }} onClick={() => setmanuuunoti(!manuuunoti)}></div>
          <div


          style={{
            position: 'absolute',
            top: '100%',
            right: 0,
            backgroundColor: '#fff',
            border: '1px solid #ccc',
            borderRadius: '5px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            zIndex: 1050,
            padding: '10px',
            width: 'auto',
            whiteSpace: 'nowrap',
          }}
          >
          {manulist.map((item, index) => (
            <div

            key={index}
            onClick={() => {
              // setmanuuunoti(false);
              navigation(item.link);
              //  alert("ok")
            }}
            style={{
              padding: '8px 12px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              color: prinarycolor,
              width: 'fit-content !important',

              textWrap: "none",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = prinarycolor;
              e.currentTarget.style.color = prinarycolortext;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = prinarycolor;
            }}
            >
            {item.icon}
            {item.title}
            </div>
          ))}
          </div>
        </>
        )}
      </div>
      </>
    );
  }



  return (
    <>
      {" "}








      <div className="navbar" style={{ color: prinarycolor }}>
        <div className="navlogo">
          <img
            alt=""
            src={logourl}
            width={"160px"}
            className="hovar"
            onClick={() => {
              navigate("/");
            }}
          />
        </div>
        {(token === "dskgfsdgfkgsdfkjg35464154845674987dsf@53" ||
          token === "sdrfg&78967daghf#wedhjgasj(dlsh6kjsdg") && (
            <>
              <div className="navmanu" style={{ display: "flex", gap: "20px" }}>


                <Profilelist />
              </div>
            </>
          )}
        <div className="navmanumob">


          {(token === "dskgfsdgfkgsdfkjg35464154845674987dsf@53" ||
            token === "sdrfg&78967daghf#wedhjgasj(dlsh6kjsdg") && (
              <>

                <Profilelist />
                {manuuu === false && (
                  <>
                    {" "}
                    <h5
                      onClick={() => setmanu(true)}
                      className="hovar"
                      style={{
                        margin: "0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: prinarycolor,
                      }}
                    >
                      {" "}
                      <FaBars style={{ width: "30px", height: "30px" }} />{" "}
                    </h5>
                  </>
                )}
                {manuuu === true && (
                  <>
                    {" "}
                    <h5
                      onClick={() => setmanu(false)}
                      className="hovar"
                      style={{
                        margin: "0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: prinarycolor,
                      }}
                    >
                      {" "}
                      <ImCross style={{ width: "30px", height: "30px" }} />{" "}
                    </h5>
                  </>
                )}
              </>
            )}
        </div>
      </div>



      {manuuu === true && (
        <>
          {" "}
          <div className="mobmanubg" onClick={() => setmanu(false)}>
            {" "}
          </div>
          <div className="mobmanu" style={{ color: prinarycolor }}>



            <MainHeading />



          </div>
        </>
      )}
    </>
  );
}

export default Navbar;




{/* notification  */ }
{/* {token === "dskgfsdgfkgsdfkjg35464154845674987dsf@53" && (
        <>
          {manuuunoti === true && (
            <>
              <div
                className="notificationbg"
                onClick={() => setmanuuunoti(false)}
              >
                {" "}
              </div>
              <div className="notifications">
                {notification.map((value, index) => {
                  return (
                    <>
                      <div
                        className={`subnoti ${value.status === false ? "bglight" : ""
                          }`}
                      >
                        <h4 style={{ margin: 0 }}>{value.title}</h4>
                        <p style={{ margin: 0 }}>{value.contant}</p>

                        {value.status === false && (
                          <>
                            <button
                              onClick={() => {
                                const hide = message.loading(
                                  "Action in progress",
                                  0
                                );
                                var myHeaders = new Headers();
                                myHeaders.append(
                                  "Content-Type",
                                  "application/x-www-form-urlencoded"
                                );

                                var urlencoded = new URLSearchParams();
                                urlencoded.append("_id", value._id);

                                var requestOptions = {
                                  method: "POST",
                                  headers: myHeaders,
                                  body: urlencoded,
                                  redirect: "follow",
                                };

                                fetch(
                                  "https://yourgutmap-food-sensitivity-423a2af84621.herokuapp.com/editnotification",
                                  requestOptions
                                )
                                  .then((response) => response.json())
                                  .then((result) => {
                                    setnotification(result);
                                    // setmanuuunoti(false)
                                  });

                                setTimeout(() => {
                                  hide(); // Call hide to stop the loading message
                                  message.success(
                                    "Action completed successfully"
                                  );
                                }, 2000);
                              }}
                              className="button"
                            >
                              Mark as Read
                            </button>
                          </>
                        )}
                      </div>
                    </>
                  );
                })}
              </div>
            </>
          )}
        </>
      )} */}
